<style lang="scss">
.change-no{
    display: flex;
    align-items: center;
    justify-content: space-around;
    width:60px;
    height: 40px;
    border: 1px solid #c5c5c5;
    border-radius: 6px;
    .change-no-icon{
        display: flex;
        flex-direction: column;
        cursor: pointer;
        .el-icon-caret-top:hover,.el-icon-caret-bottom:hover{
            color: #5cb6ff;
        }
    }
}
.radioLabelNone .el-radio__label{
	display: none;
}
</style>
<template>
	<div>
		<div class="media-add-ep-list">
			<div class="top-search">
				<el-form :inline="true" ref="formInline" :model="formInline" size="small" class="demo-form-inline">
					<!--<el-form-item label="方案名称：" prop="planName">	-->
						<!--<el-input v-model="formInline.planName" placeholder="请输入方案名称" clearable @keyup.enter.native="search" @clear="search" style="width: 200px;"></el-input>-->
					<!--</el-form-item>-->
					<!--<el-form-item>-->
						<!--<el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>-->
					<!--</el-form-item>-->
					<el-form-item v-if="menuPage == 'agent'">
						<el-button type="success" v-has="'agentRechargePlan:add'" icon="el-icon-circle-plus-outline"  @click="addData">添加</el-button>
					</el-form-item>
				</el-form>
			</div>
			<div class="tableTh" v-height>
				<!-- 充值方案配置 -->
				<el-table :data="tableData.result" border stripe style="width: 100%" height="100%" class="tableStyle td20">
					<el-table-column prop="orderNo" label="序号" width="60">
						<template slot-scope="scope">
							<span>{{scope.row.orderNo}} </span>
						</template>
					</el-table-column>
					<el-table-column label="方案名称" width="120">
						<template slot-scope="scope">
							<span>{{ scope.row.planName }}</span>
						</template>
					</el-table-column>
					<el-table-column label="充值方案（首充）">
						<template slot-scope="scope">
							<p v-for="(item,index) in scope.row.firstRecharge" :key="index">
								<span>
									充值类型：{{ item.rechargeType == 1 ? '普通会员' : '连续续费会员' }}；
								</span>
								<span>实付金额：{{item.money}}；</span>
								<span>金币数量：{{item.rechargeType==0?item.money * 100 + item.present:0}}；</span>
								<span>充值说明：{{item.rechargeInfo}}；</span>
							</p>
						</template>
					</el-table-column>
					<el-table-column label="充值方案（复充）">
						<template slot-scope="scope">
							<p v-for="(item,index) in scope.row.againRecharge" :key="index">
								<span>
									充值类型：{{ item.rechargeType == 1 ? '普通会员' : '连续续费会员' }}；
								</span>
								<span>实付金额：{{item.money}}；</span>
								<span>金币数量：{{item.rechargeType==0?item.money * 100 + item.present:0}}；</span>
								<span>充值说明：{{item.rechargeInfo}}；</span>
							</p>
						</template>
					</el-table-column>
					<el-table-column label="小程序" width="120">
						<template slot-scope="scope">
							<span>{{ scope.row.appName }}</span>
						</template>
					</el-table-column>
					<el-table-column label="操作" width="350">
						<template slot-scope="scope" class="ddd">
							<el-button type="defult" icon="el-icon-warning-outline" size="mini" @click="handleWayLook(scope.row.id)">详情</el-button>
							<el-button type="defult" v-has="menuPage == 'agent' ? 'agentRechargePlan:configuration' : 'agentRechargePlan:configuration'" icon="el-icon-setting" size="mini" @click="handleConfig(scope.row.id)">配置</el-button>
							<el-button type="primary" v-has="menuPage == 'agent' ? 'agentRechargePlan:update' : 'rechargePlan:update'" icon="el-icon-edit" size="mini" @click="handleEdit(scope.row.id)">编辑</el-button>
						</template>
					</el-table-column>
				</el-table>

				<div class="foot-table" style="text-align:center;">
					<el-pagination
						@current-change="handleCurrentChange"
						@size-change="handleSizeChange"
						:page-sizes="[20, 50, 100, 200, 500]"
						:page-size="tableData.pageSize"
						background
						:current-page="currentPage"
						layout="sizes, prev, pager, next, jumper, ->, total"
						:total="tableData.totalNum">
					</el-pagination>
				</div>
			</div>

		</div>
		<!--充值配置详情-->
		<el-dialog title="详情" :visible.sync="dialogWayInfoVisible" center width="800px">
			<table class="el-table el-table--border el-table--enable-row-hover mytable" cellspacing="0" cellpadding="0">
				<tbody>
					<tr>
						<td width="200">方案名称</td>
						<td>
							<span>{{ ruleForm.planName }}</span>
						</td>
					</tr>
					<tr>
						<td width="200">充值方案（首充）</td>
						<td>
							<p v-for="(item,index) in ruleForm.firstRecharge" :key="index">
								<span>
									充值类型：{{ item.rechargeType == 1 ? '普通会员' : '连续续费会员' }}；
								</span>
								<span>实付金额：{{item.money}}；</span>
								<span>金币数量：{{item.rechargeType==0?item.money * 100 + item.present:0}}；</span>
								<span>充值说明：{{item.rechargeInfo}}；</span>
							</p>
						</td>
					</tr>
					<tr>
						<td width="200">充值方案（复充）</td>
						<td>
							<p v-for="(item,index) in ruleForm.againRecharge" :key="index">
								<span>
									充值类型：{{ item.rechargeType == 1 ? '普通会员' : '连续续费会员' }}；
								</span>
								<span>实付金额：{{item.money}}；</span>
								<span>金币数量：{{item.rechargeType==0?item.money * 100 + item.present:0}}；</span>
								<span>充值说明：{{item.rechargeInfo}}；</span>
							</p>
						</td>
					</tr>
					<tr>
						<td>小程序</td>
						<td>
							<p>{{ ruleForm.appName }}</p>
						</td>
					</tr>
				</tbody>
			</table>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="dialogWayInfoVisible = false">确 定</el-button>
			</div>
		</el-dialog>
		<!-- 充值方案编辑 -->
		<el-dialog :dialogTitle="dialogTitle" :visible.sync="dialogWayFormVisible" width="600px">
			<el-form :rules="rules" ref="ruleForm" :model="ruleForm" label-width="150px" class="input350" style="max-height: 480px;overflow: auto; padding-right: 20px;">
				<el-form-item label="方案名称：" prop="planName">
					<el-input v-model="ruleForm.planName" placeholder="请输入方案名称" clearable></el-input>
				</el-form-item>
				<el-form-item label="排序：" prop="path">
					<el-input type="number" v-model="ruleForm.orderNo" placeholder="请输入排序" clearable></el-input>
				</el-form-item>
				<el-form-item label="小程序" prop="appName">
					<el-input  v-model="ruleForm.appName" disabled placeholder="请输入小程序" clearable></el-input>
					<!-- <app-list @getAppId="getConfigAppId" :appId="ruleForm.appId" :clear="'noclear'" style="width: 90%;"></app-list> -->
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogWayFormVisible = false">取 消</el-button>
				<el-button type="primary" @click="editDialogSureBtn('ruleForm')">确 定</el-button>
			</div>
		</el-dialog>
		<!--充值方案配置-->
		<el-dialog :dialogTitle="dialogTitle" :visible.sync="dialogConfigVisible" width="800px">
			<div style="position: relative;">
				<el-form>
					<el-form-item label="" prop="firstRecharge">
						<div style="display: flex;">
							<p>充值方案（首充）：</p>
							<el-button type="primary" size="mini" style="height: 30px;margin: 6px 0 16px 10px" @click="addGear(1,ruleForm.firstRecharge)">添加</el-button>
						</div>
						<el-table :data="ruleForm.firstRecharge" border stripe style="width: 800px;" max-height="300">
							<el-table-column label="充值类型" width="150">
								<template slot-scope="scope">
									<span v-if="scope.row.rechargeType == 1">普通会员</span>
									<span v-if="scope.row.rechargeType == 2">
										连续续费会员
									</span>
								</template>
							</el-table-column>
							<el-table-column label="充值金额"  width="150">
								<template slot-scope="scope">
									<p>实付金额：{{ scope.row.money }}</p>
									<p>划线价：{{ scope.row.originalPrice }}</p>
								</template>
							</el-table-column>
							<el-table-column label="其他信息" >
								<template slot-scope="scope">
									<p>金币数量：{{scope.row.rechargeType==0? (scope.row.money || 0) * 100 + (scope.row.present || 0):0 }}</p>
									<p>充值说明：{{ scope.row.rechargeInfo }}</p>
									<p>档位描述：{{ scope.row.templateInfo }}</p>
								</template>
							</el-table-column>
							<el-table-column prop="orderNo" label="序号" width="80" >
								<template slot-scope="scope">
                                    <div class="change-no">
                                        <span>{{scope.row.orderNo}} </span>
                                        <div class="change-no-icon">
                                            <i class="el-icon-caret-top" @click="FirChangeOrderNo('up',scope.$index)"></i>
                                            <i class="el-icon-caret-bottom" @click="FirChangeOrderNo('down',scope.$index)"></i>
                                        </div>
                                    </div>
									<!-- <span>{{scope.row.orderNo}} </span> -->
								</template>
							</el-table-column>
							<el-table-column label="默认选中" align="center" width="80" >
								<template slot-scope="scope">
									<div class="radioLabelNone">
										<el-radio v-model="selectedIdFirst" :label="scope.row.templateId" @change="changeRadio(1, ruleForm.id, scope.row.templateId)"></el-radio>
									</div>
								</template>
							</el-table-column>
							<el-table-column label="操作" width="80">
								<template slot-scope="scope" class="ddd">
									<el-popover width="150" :ref="scope.row.id" style="margin-left: 10px;">
										<p class="popover-con del">
											<i class="el-icon-question warnning-text"></i>确定删除吗？
										</p>
										<div style="text-align: right; margin: 0">
											<el-button size="mini" @click="$refs[scope.row.id].doClose()">取消</el-button>
											<el-button type="primary" size="mini" @click="delGear(scope.row.id)">确定</el-button>
										</div>
										<el-button slot="reference" type="danger" icon="el-icon-delete" size="mini"></el-button>
									</el-popover>
								</template>
							</el-table-column>
						</el-table>
					</el-form-item>
					<el-form-item label="" prop="againRecharge">
						<div style="display: flex;">
							<p>充值方案（复充）：</p>
							<el-button type="primary" size="mini" style="height: 30px;margin: 6px 0 16px 10px" @click="addGear(0,ruleForm.againRecharge)">添加</el-button>
						</div>
						<el-table :data="ruleForm.againRecharge" border stripe style="width: 100%;" max-height="300">
							<el-table-column label="充值类型"  width="150">
								<template slot-scope="scope">
									<span v-if="scope.row.rechargeType == 1">普通会员</span>
									<span v-if="scope.row.rechargeType == 2">
										连续续费会员
									</span>
								</template>
							</el-table-column>
							<el-table-column label="充值金额" width="150" >
								<template slot-scope="scope">
									<p>实付金额：{{ scope.row.money }}</p>
									<p>划线价：{{ scope.row.originalPrice }}</p>
								</template>
							</el-table-column>
							<el-table-column label="其他信息" >
								<template slot-scope="scope">
									<p>金币数量：{{ scope.row.rechargeType==0?(scope.row.money || 0) * 100 + (scope.row.present || 0):0 }}</p>
									<p>充值说明：{{ scope.row.rechargeInfo }}</p>
									<p>档位描述：{{ scope.row.templateInfo }}</p>
								</template>
							</el-table-column>
							<el-table-column prop="orderNo" label="序号" width="80" >
								<template slot-scope="scope">
                                    <div class="change-no">
                                        <span>{{scope.row.orderNo}} </span>
                                        <div class="change-no-icon">
                                            <i class="el-icon-caret-top"  @click="agChangeOrderNo('up',scope.$index)"></i>
                                            <i class="el-icon-caret-bottom"  @click="agChangeOrderNo('down',scope.$index)"></i>
                                        </div>
                                    </div>
									<!-- <span>{{scope.row.orderNo}} </span> -->
								</template>
							</el-table-column>
							<el-table-column label="默认选中" align="center" width="80" >
								<template slot-scope="scope">
									<div class="radioLabelNone">
										<el-radio v-model="selectedIdagain" :label="scope.row.templateId" @change="changeRadio(0, ruleForm.id, scope.row.templateId)"></el-radio>
									</div>
								</template>
							</el-table-column>
							<el-table-column label="操作" width="80">
								<template slot-scope="scope" class="ddd">
									<el-popover width="150" :ref="scope.row.id" style="margin-left: 10px;">
										<p class="popover-con del">
											<i class="el-icon-question warnning-text"></i>确定删除吗？
										</p>
										<div style="text-align: right; margin: 0">
											<el-button size="mini" @click="$refs[scope.row.id].doClose()">取消</el-button>
											<el-button type="primary" size="mini" @click="delGear(scope.row.id)">确定</el-button>
										</div>
										<el-button slot="reference" type="danger" icon="el-icon-delete" size="mini"></el-button>
									</el-popover>
								</template>
							</el-table-column>
						</el-table>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogConfigVisible = false">关 闭</el-button>
				<!-- <el-button type="primary" @click="editDialogSureBtn('ruleForm')">确 定</el-button> -->
			</div>
		</el-dialog>
		<recharge-table-more :visible.sync="isShowDialogRecharge" :selectList="selectList" :appId="formInline.appId" @gearSure="gearSure" @cancelDialogRecharge="cancelDialogRecharge"></recharge-table-more>
	</div>
</template>
<script>
import RechargeTableMore from '@/components/wbdp/RechargeTableMore'
import {waylist, wayDetails, wayAdd, listWayAdd, delWay, planOrder, selected} from "@/api/wb/app/recharge";
export default {
    name:'AppRechargePlan',
	components: {
		RechargeTableMore
	},
	props:['menuPage'],
	data() {
		// var validateNum = (rule, value, callback) => {
		// 	if (!(/(^[1-9]\d*$)/.test(value))) {
		// 		return callback(new Error('数字应为正整数'));
		// 	} else {
		// 		callback();
		// 	}
		// };
		return {
			formInline: {
				appId: localStorage.getItem('appId'),
				planName:''
			},
			dialogTitle: '添加充值档位',
			tableData: {
				pageSize: 20,
				pageNo: 1,
				totalPage: 1,
				totalNum: 0,
				result: [
				]
			},
			currentPage: 1,
			currentConfigPage:1,
			dialogFormVisible: false,
			dialogConfigVisible:false,
			dialogWayFormVisible:false,
            // ruleForm: {},
            dialogInfoVisible: false,
			dialogWayInfoVisible:false,
			durationTypeOptions: [ // 类型
				{
					value: 0,
					label: '充值金币'
				},
                {
                    value: 1,
                    label: '月度会员'
                },
                {
                    value: 2,
                    label: '季度会员'
                },
                {
                    value: 3,
                    label: '年度会员'
                },
			],
			ruleForm: {
				appId:'',
                id:'',
                orderNo:'',
                planName:'',
                appName:''
			},
			rules: {
                appId: [
					{required: true, message: '请填写小程序', trigger: 'change'}
				],
                planName: [
                    {required: true, message: '请输入方案名称', trigger: 'blur'},
                    // { validator: validateNum, trigger: 'blur' }
                ],
				orderNo: [
					{required: true, message: '请输入排序', trigger: 'blur'},
				]
			},
			isShowDialogRecharge: false,
			planId:null,
			selectRecharge: {},
            dataIds: '', //档位id
			isFirstRecharge:1,
			selectList:[],
            selectedIdFirst: '',
            selectedIdagain: ''
		}
	},
	computed: {},
	watch: {
        // selectedIdFirst(newId) {
         //    console.log('selected', newId)
         //    this.changeSelected()
		// }
	},
	mounted: function() {
        console.log(22)
		this.getTableData()
	},
	methods: {
		// search () {
		// 	this.currentPage = 1
		// 	this.getTableData()
		// },
        changeRadio(isFirstRecharge, planId, templateId) {
            console.log(isFirstRecharge, planId, templateId)
			this.changeSelected(isFirstRecharge, planId, templateId)
		},
		// 从组件获取appid
		getAppId(data) {
			this.formInline.appId = data
			this.getTableData()
		},
        search() {
            this.currentPage = 1
            this.getTableData()
		},
		// 分页
		handleCurrentChange(value) {
			this.currentPage = value
			this.getTableData()
		},
		// pageSize切换
		handleSizeChange (val) {
			this.tableData.pageSize  = val
			this.currentPage = 1
			this.getTableData()
		},
		// 编辑
		handleEdit(id) {
			if (this.$refs['ruleForm'] !== undefined) {
				this.$refs['ruleForm'].resetFields()
			}
			
            this.dialogTitle = '编辑充值方案'
            this.dialogWayFormVisible = true
            this.getWayDetails(id)
			
			
		},
		//充值方案配置详情
		getWayDetails(id) {
            wayDetails({
				id: id
			}).then(response => {
                if (response.data.head.flag === 0) {
                    this.ruleForm = response.data.content
					this.ruleForm.change = 'upd'
                    response.data.content.firstRecharge.forEach((element) => {
                        if (element.selected == 1) {
                            this.selectedIdFirst = element.templateId
						}
					})
                    response.data.content.againRecharge.forEach((element) => {
                        if (element.selected == 1) {
                            this.selectedIdagain = element.templateId
                        }
                    })
                } else {
                    this.$message.error(response.data.head.desc)
                }
            });  
		},
		addData() {
			const appName = JSON.parse(localStorage.getItem('appList')).filter(item => item.appId === this.formInline.appId)[0].name
			this.ruleForm = {
				appId:this.formInline.appId,
                id:'',
                orderNo:'',
                planName:'',
                appName:appName,
			}
			
            this.dialogWayFormVisible = true
            this.dialogTitle = '添加充值方案'
			
			if (this.$refs['ruleForm'] !== undefined) {
				this.$refs['ruleForm'].resetFields()
			}
		},
		// 弹框确定
		editDialogSureBtn (formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					this.saveTableData('add')
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		},
		// 保存编辑信息
		saveTableData () {
			console.log(this.ruleForm)
            const info = {
                appId:this.formInline.appId || '',
                id:this.ruleForm.id || '',
                orderNo:this.ruleForm.orderNo || '',
                planName:this.ruleForm.planName || ''
            }
            // let json3 = {
            //     appId: this.formInline.appId
            // };
            // let json4 = this.ruleForm;
            // let paramJson1 = { ...json3, ...json4 }
			
            wayAdd(info).then(response => {
                if (response.data.head.flag === 0) {
                    this.$message({
                        message: '提交成功',
                        type: 'success'
                    });
                    this.getTableData()
                    this.dialogWayFormVisible = false
                } else {
                    this.$message.error(response.data.head.desc);
                }
            })
        
			
		},
		getTableData() {
            console.log(33)
			let json2 = {
				pageNo: this.currentPage,
				pageSize: this.tableData.pageSize
			};
            let json1 = this.formInline;
            let paramJson = { ...json1, ...json2 }
            waylist(paramJson).then(response => {
                if (response.data.head.flag === 0) {
                    this.tableData = response.data.content
                } else {
                    this.$message.error(response.data.head.desc)
                }
            })

		},

		//充值配置方案详情
		handleWayLook(id){
			this.dialogWayInfoVisible = true
            this.getWayDetails(id)
		},
		//充值方案配置
		handleConfig(id){
			this.dialogTitle = '充值方案配置'
			this.dialogConfigVisible = true
			this.planId = id;
			this.getWayDetails(id)
		},
		
		//确定选择档位
        gearSure(data) {
            console.log(data)
            this.dataIds = data.selectListStr
            this.selectRecharge = data
            listWayAdd({
                templateIds: this.dataIds,
                planId: this.planId,
				isFirstRecharge:this.isFirstRecharge
			}).then(response => {
                if (response.data.head.flag === 0) {
                    // this.getTableDataRecharge()
					this.getTableData()
					this.getWayDetails(this.planId)
                } else {
                    this.$message.error(response.data.head.desc)
                }
            });
        },
		// 关闭充值档位弹窗
        cancelDialogRecharge(data) {
            console.log('cancel')
            this.isShowDialogRecharge = data
        },
		//添加充值档位
		addGear(val,list){
			this.isShowDialogRecharge = true
			this.isFirstRecharge = val;
			this.selectList = list;
			if(val==1){
				console.log("首充planid",this.planId)
			}else{
				console.log("复充planid",this.planId)
			}
		},
		//删除已配置的档位
		delGear(id){
			console.log("idididi",id)
			delWay({
                id: id,
            }).then(response => {
                if (response.data.head.flag === 0) {
                    // if (this.tableData.result.length === 1 && this.currentPage > 1) {
                    //     this.currentPage =  this.currentPage - 1
                    // }
                    this.$refs[id].doClose()
                    this.getTableData()
					this.getWayDetails(this.planId)
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                } else {
                    this.$message.error(response.data.head.desc);
                }
            })
		},
        onPlanOrder(list){
            list.forEach((element,index) => {
                planOrder({
                    id: element.id,
                    orderNo:index + 1
                }).then(response => {
                    if (response.data.head.flag === 0) {
                        this.getTableData()
                        this.getWayDetails(this.planId)
                    } else {
                        this.$message.error(response.data.head.desc);
                    }
                })   
            });
           
        }, 
        //改变配置方案的档位顺序(首充)
        FirChangeOrderNo(type,index){
            if(type == 'up'){//上移
                if(index == 0){
                    this.$message.warning('已在第一位,不能上移');
                    return ;
                }
                const upDate = this.ruleForm.firstRecharge[index - 1];
                this.ruleForm.firstRecharge.splice(index - 1, 1);
                this.ruleForm.firstRecharge.splice(index, 0, upDate);
                this.onPlanOrder(this.ruleForm.firstRecharge)

            }else{//下移
                if(index == this.ruleForm.firstRecharge.length - 1){
                    this.$message.warning('已经是最后一条，不可下移');
                    return ;
                }
                const downDate = this.ruleForm.firstRecharge[index + 1];
                this.ruleForm.firstRecharge.splice(index + 1, 1);
                this.ruleForm.firstRecharge.splice(index, 0, downDate);
                this.onPlanOrder(this.ruleForm.firstRecharge)
            }   
        },
        //改变配置方案的档位顺序(复充)
        agChangeOrderNo(type,index){
            if(type == 'up'){//上移
                if(index == 0){
                    this.$message.warning('已在第一位,不能上移');
                    return ;
                }
                const upDate = this.ruleForm.againRecharge[index - 1];
                this.ruleForm.againRecharge.splice(index - 1, 1);
                this.ruleForm.againRecharge.splice(index, 0, upDate);
                this.onPlanOrder(this.ruleForm.againRecharge)

            }else{//下移
                if(index == this.ruleForm.againRecharge.length - 1){
                    this.$message.warning('已经是最后一条，不可下移');
                    return ;
                }
                const downDate = this.ruleForm.againRecharge[index + 1];
                this.ruleForm.againRecharge.splice(index + 1, 1);
                this.ruleForm.againRecharge.splice(index, 0, downDate);
                this.onPlanOrder(this.ruleForm.againRecharge)
            }   
        },
        //充值方案配置详情
        changeSelected(isFirstRecharge, planId, templateId) {
            selected({
                isFirstRecharge: isFirstRecharge,
                planId: planId,
                templateId: templateId
            }).then(response => {
                if (response.data.head.flag === 0) {
                    this.getWayDetails(planId)
                } else {
                    this.$message.error(response.data.head.desc)
                }
            });
        },
	}
}
</script>
